import React from 'react';
import {Box, Button, Divider, Stack, TextField, FormLabel, Paper, IconButton} from '@mui/material';
import Typography from '@mui/material/Typography';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MessageDialog from '../tools/MessageDialog';
import * as ETVConstants from '../ETVConstants';
import { Delete } from '@mui/icons-material';

const MAX_IO_BITS = 32;
const MAX_FLOOR_BITS = 32;
class EditIO extends React.Component {

    state = {
		ioMap: {
			bit_0:'bit_0_floor', bit_1:'bit_1_floor', bit_2:'bit_2_floor', bit_3:'bit_3_floor', bit_4:'bit_4_floor', bit_5:'bit_5_floor', bit_6:'bit_6_floor', bit_7:'bit_out_of_service', bit_8:'bit_arriving',bit_9:'bit_overload',bit_10:'bit_up',	bit_11:'bit_down',bit_12:'bit_fire_alarm',bit_13:'bit_door_state_1',bit_14:'bit_door_state_2',bit_15:'bit_intercom',
			bit_16:'-1', bit_17:'-1', bit_18:'-1', bit_19:'-1', bit_20:'-1', bit_21:'-1', bit_22:'-1', bit_23:'-1', bit_24:'-1',bit_25:'-1',bit_26:'-1',bit_27:'-1',bit_28:'-1',bit_29:'-1',bit_30:'-1',bit_31:'-1'
		},
		door_map: {closed:'10',opening:'11',open:'01',closing:'11'},
		xor_mask: '0'.repeat(MAX_IO_BITS),
		info_message:"",
		info_title:"",
		info_type:"info",
		special_io_obj:{},
	}

    componentDidMount() {
      this.loadConfig();
    }

	getBit( bitNr, jsonResult) {
		if(bitNr==16) {
			console.log("xxxtest "+JSON.stringify(jsonResult));
		}
		if (jsonResult[bitNr]) return jsonResult[bitNr];
		return "-1";
	}

    loadConfig() {
      	//console.log("---------------------loading deviceIOs");
		var url = ETVConstants.getServerBase()+"/elevator_config?device_id="+this.props.device_id+"&action=get_io_mapping";
      	//console.log("loading url="+url);
      	fetch(url)
        .then(res => res.json())
        .then(
          (result) => {
            console.log("xconfig="+JSON.stringify(result));
			var ioMap = {
				bit_0:this.getBit("0",result),
				bit_1:this.getBit("1",result),
				bit_2:this.getBit("2",result),
				bit_3:this.getBit("3",result),
				bit_4:this.getBit("4",result),
				bit_5:this.getBit("5",result),
				bit_6:this.getBit("6",result),
				bit_7:this.getBit("7",result),
				bit_8:this.getBit("8",result),
				bit_9:this.getBit("9",result),
				bit_10:this.getBit("10",result),
				bit_11:this.getBit("11",result),
				bit_12:this.getBit("12",result),
				bit_13:this.getBit("13",result),
				bit_14:this.getBit("14",result),
				bit_15:this.getBit("15",result),
				bit_16:this.getBit("16",result),
				bit_17:this.getBit("17",result),
				bit_18:this.getBit("18",result),
				bit_19:this.getBit("19",result),
				bit_20:this.getBit("20",result),
				bit_21:this.getBit("21",result),
				bit_22:this.getBit("22",result),
				bit_23:this.getBit("23",result),
				bit_24:this.getBit("24",result),
				bit_25:this.getBit("25",result),
				bit_26:this.getBit("26",result),
				bit_27:this.getBit("27",result),
				bit_28:this.getBit("28",result),
				bit_29:this.getBit("29",result),
				bit_30:this.getBit("30",result),
				bit_31:this.getBit("31",result)
			};
			var closing = result['bits_door_closing'];
			if(closing) {
				closing = closing.substring(0,2);
			}else{
				closing = '11';
			}
			var opening = result['bits_door_opening'];
			if(opening) {
				opening = opening.substring(0,2);
			}else{
				opening = '11';
			}
			var open = result['bits_door_open'];
			if(open) {
				open = open.substring(0,2);
			}else{
				open = '01';
			}
			var closed = result['bits_door_closed'];
			if (closed) {
				closed = closed.substring(0,2);
			}else{
				closed = '10';
			}
			var xorMask = result['xor_mask'];
			if(!xorMask || xorMask==='undefined') {
				xorMask = '0'.repeat(MAX_IO_BITS);
			}else if(xorMask.length < MAX_IO_BITS) {
				xorMask = xorMask.padStart(MAX_IO_BITS, '0');
			}
			var doorMap = {open:open,closing:closing,closed:closed,opening:opening};
			var specialIOObj = this.loadSpecialIOConfig(result);
			this.setState({ioMap:ioMap,door_map:doorMap,xor_mask:xorMask,special_io_obj:specialIOObj});
          },
          // Note: it's important to handle errors here
          // instead of a catch() block so that we don't swallow
          // exceptions from actual bugs in components.
          (error) => {
            this.setState({
              error
            });
          }
        )
    }

	loadSpecialIOConfig( serverConfig) {
		var res = {};
		for(var i=1; i<=16; i++) {
			if(serverConfig["special_io_"+i+".event"]) {
				res["special_io_"+i+".event"] = serverConfig["special_io_"+i+".event"];
				res["special_io_"+i+".value"] = serverConfig["special_io_"+i+".value"];
				res["special_io_"+i+".extra"] = serverConfig["special_io_"+i+".extra"];
			}
		}
		//console.log("--->specialIOObj="+JSON.stringify(res));
		return res;
	}

	getSpecialIOs() {
		var res = [];
		Object.keys(this.state.special_io_obj).forEach(key => {
			var index = this.extractIndexFromKey(key);
			if(!res.includes(index)) res.push(index);
		});
		return res;
	}

	extractIndexFromKey(str) {
		const prefix = "special_io_";
		const suffixIndex = str.indexOf(".", prefix.length);
		
		if (str.startsWith(prefix) && suffixIndex !== -1) {
		  return str.substring(prefix.length, suffixIndex);
		}
		return null; // or throw error / return -1 if needed
	}


    showWindow(divID, show) {
      	show?this.setState({window:divID}):this.setState({window:''});
    }

	addToSpecialIOs(i) {
		var curObj = this.state.special_io_obj;
		var key0 = "special_io_"+i+".event";
		if(curObj.hasOwnProperty(key0)) {
			//already set
			return;
		}
		curObj["special_io_"+i+".event"]="";
		curObj["special_io_"+i+".value"]="";
		curObj["special_io_"+i+".extra"]="";
		this.setState({special_io_obj:curObj});
	}  

	extractNumberFromIOString(str) {
		const lastUnderscoreIndex = str.lastIndexOf('_');
		if (lastUnderscoreIndex === -1) return null;
	  
		const numberPart = str.substring(lastUnderscoreIndex + 1);
		const parsedNumber = parseInt(numberPart, 10);
	  
		return isNaN(parsedNumber) ? null : parsedNumber;
	  }

	setIOMap( key, value) {
		console.log("xxx setting key="+key+" value="+value);
		if(value.indexOf("bit_special_io_")==0) {
			this.addToSpecialIOs(this.extractNumberFromIOString(value));
		}

		var props = this.state.ioMap;
		////console.log(JSON.stringify(props, null, 2));
		props[key]=value;
		this.setState({ioMap:props});
	}

	showInfoMessage(title,msg) {
		this.setState({window:'message_div', info_type:'info', info_title:title, info_message:msg});
	}

	showSuccessMessage(title,msg) {
		this.setState({window:'message_div', info_type:'success', info_title:title, info_message:msg});
	}

	showErrorMessage(title,msg) {
		this.setState({window:'message_div', info_type:'error', info_title:title, info_message:msg});
	}

	closeInfoMessage() {
		this.setState({window:'', info_title:'', info_message:undefined, info_type:'info'});
	}

	setDefault() {
		var defaultMap = {
			bit_0:'bit_0_floor',
			bit_1:'bit_1_floor',
			bit_2:'bit_2_floor',
			bit_3:'bit_3_floor',
			bit_4:'bit_4_floor',
			bit_5:'bit_5_floor',
			bit_6:'bit_6_floor',
			bit_7:'bit_out_of_service',
			bit_8:'bit_arriving',
			bit_9:'bit_overload',
			bit_10:'bit_up',
			bit_11:'bit_down',
			bit_12:'bit_fire_alarm',
			bit_13:'bit_door_state_1',
			bit_14:'bit_door_state_2',
			bit_15:'bit_intercom',
			bit_16:'-1',			
			bit_17:'-1',
			bit_18:'-1',
			bit_19:'-1',
			bit_20:'-1',
			bit_21:'-1',
			bit_22:'-1',
			bit_23:'-1',
			bit_24:'-1',
			bit_25:'-1',
			bit_26:'-1',
			bit_27:'-1',
			bit_28:'-1',
			bit_29:'-1',
			bit_30:'-1',
			bit_31:'-1',
			special_io_obj:{},
		};
		this.setState({ioMap:defaultMap});
	}

	setDefaultDoor() {
		var defaultDoor = {closed:'10',opening:'11',open:'01',closing:'11'}
		this.setState({door_map:defaultDoor});
	}

	setDoorConfig( key, value) {
		var props = this.state.door_map;
		//console.log("setDoorConfig key="+key+" value="+value);
		props[key]=value;
		this.setState({door_map:props});
	}

	getInputLabel( bit) {
		//e.g. bit_0
		var nr = parseInt(bit.substring(4,bit.length));
		if(nr<16) return "Adam 1, Input "+nr;
		return "Adam 2, Input "+(nr-16);
	}

	createDropDown( inputKey) {
		var curVal = this.state.ioMap[inputKey];
		//console.log("swVersion="+this.props.sw_version);
		return (
		<FormControl fullWidth>
				<InputLabel>{this.getInputLabel(inputKey)}</InputLabel>
				<Select
					label={"input_"+this.getInputLabel(inputKey)}
					id={"input_"+inputKey}
					value={curVal}
					size="small"
					style={{ width: '100%'}}
					onChange={(e)=>{this.setIOMap(inputKey,e.target.value)}}>
					<MenuItem value='-1'>--- undefined ---</MenuItem>
					{[...Array(MAX_FLOOR_BITS)].map((_, i) => (
						<MenuItem key={"floor_bit_"+i} value={"bit_"+i+"_floor"}>FLOOR BIT {i}</MenuItem>
					))}
					<MenuItem value='bit_up'>arrow UP</MenuItem>
					<MenuItem value='bit_down'>arrow Down</MenuItem>
					<MenuItem value='bit_overload'>Overload</MenuItem>
					<MenuItem value='bit_fire_alarm'>Fire Alarm</MenuItem>
					<MenuItem value='bit_out_of_service'>Out of Service</MenuItem>
					<MenuItem value='bit_arriving'>Arriving Signal</MenuItem>
					<MenuItem value='bit_door_state_1'>Door Input 1</MenuItem>
					<MenuItem value='bit_door_state_2'>Door Input 2</MenuItem>
					<MenuItem value='bit_intercom'>Intercom  Signal</MenuItem>
					<MenuItem value='bit_intercom_btn_yes'>Intercom  YES Button</MenuItem>
					<MenuItem value='bit_intercom_btn_no'>Intercom  NO Button</MenuItem>
					<MenuItem value='bit_maintenance'>Maintenance</MenuItem>
					<MenuItem value='bit_emergency_power'>Emergency Power</MenuItem>
					<MenuItem value='bit_service_upper_deck'>Service Upper Deck</MenuItem>
					<MenuItem value='bit_service_lower_deck'>Service Lower Deck</MenuItem>
					<MenuItem value='bit_special_io_1'>Special IO 1 </MenuItem>
					<MenuItem value='bit_special_io_2'>Special IO 2 </MenuItem>
					<MenuItem value='bit_special_io_3'>Special IO 3 </MenuItem>
					<MenuItem value='bit_special_io_4'>Special IO 4 </MenuItem>
					<MenuItem value='bit_special_io_5'>Special IO 5 </MenuItem>
					<MenuItem value='bit_special_io_6'>Special IO 6 </MenuItem>
					<MenuItem value='bit_special_io_7'>Special IO 7 </MenuItem>
					<MenuItem value='bit_special_io_8'>Special IO 8 </MenuItem>
					<MenuItem value='bit_special_io_9'>Special IO 9 </MenuItem>
					<MenuItem value='bit_special_io_10'>Special IO 10 </MenuItem>
					<MenuItem value='bit_special_io_11'>Special IO 11 </MenuItem>
					<MenuItem value='bit_special_io_12'>Special IO 12 </MenuItem>
					<MenuItem value='bit_special_io_13'>Special IO 13 </MenuItem>
					<MenuItem value='bit_special_io_14'>Special IO 14 </MenuItem>
					<MenuItem value='bit_special_io_15'>Special IO 15 </MenuItem>
					<MenuItem value='bit_special_io_16'>Special IO 16 </MenuItem>
				</Select>
			</FormControl>
		)
	}

	createDoorDropDown(inputKey) {
		var curVal = this.state.door_map[inputKey];
		return (
			<FormControl fullWidth>
				<InputLabel>{inputKey}</InputLabel>
				<Select
					label={inputKey}
					id={"input_"+inputKey}
					value={curVal}
					size="small"
					style={{ width: '100%'}}
					onChange={(e)=>{this.setDoorConfig(inputKey,e.target.value)}}>
					<MenuItem value='00'>00</MenuItem>
					<MenuItem value='01'>01</MenuItem>
					<MenuItem value='11'>11</MenuItem>
					<MenuItem value='10'>10</MenuItem>
				</Select>
			</FormControl>
		)
	}

	getValue( bitNr) {
		return this.state.ioMap["bit_"+bitNr];
	}

	saveIO() {
		const missingMultimediaFilename = this.getSpecialIOs().find((ioNumber) => {
			const key = "special_io_" + ioNumber;
			return this.state.special_io_obj[key + ".event"] === 'multimedia_message'
				&& !String(this.state.special_io_obj[key + ".value"] || '').trim();
		});
		if (missingMultimediaFilename !== undefined) {
			this.showErrorMessage(
				"IO Mapping",
				`Please enter a multimedia filename for Special IO ${missingMultimediaFilename}.`
			);
			return;
		}
		this.showInfoMessage("IO Mapping","Saving IO Mapping...");
		var url = ETVConstants.getServerBase()+"/elevator_config?action=save_io_mapping&device_id="+this.props.device_id;
		//console.log("saving settings");
		for(var i=0; i<MAX_IO_BITS; i++) {
			var val = this.state.ioMap["bit_"+i];
			if (val!=='-1') {
				url += "&"+val+"="+i;
			}
		}
		// add doorstate
		var closed = this.state.door_map["closed"];
		var closing = this.state.door_map["closing"];
		var open = this.state.door_map["open"];
		var opening = this.state.door_map["opening"];
		url += "&bits_door_open="+open+opening;
		url += "&bits_door_opening="+opening+closed;
		url += "&bits_door_closed="+closed+closing;
		url += "&bits_door_closing=" +closing+open;
		var xorMask = this.state.xor_mask || "";
		if(xorMask.length < MAX_IO_BITS) {
			xorMask = xorMask.padStart(MAX_IO_BITS, '0');
		}
		url += "&xor_mask="+xorMask;
		
		var specialIOs = this.getSpecialIOs();
		for(var i=0; i<specialIOs.length; i++) {
			var whichIO = specialIOs[i];
			var key = "special_io_"+whichIO;
			var val0 = this.state.special_io_obj[key+".event"];
			url += "&special_io_"+whichIO+".event="+encodeURIComponent(val0?val0:"");
			var val1 = this.state.special_io_obj[key+".value"];
			url += "&special_io_"+whichIO+".value="+encodeURIComponent(val1?val1:"");
			var val2 = this.state.special_io_obj[key+".extra"];
			url += "&special_io_"+whichIO+".extra="+encodeURIComponent(val2?val2:"");
		}
		//console.log("----------> aaaa URL="+url);
		fetch(url)
			.then(res => res.json())
			.then(
				(result) => {
					this.showSuccessMessage("IO Mapping","success");
				},
				(error) => {
					this.setState({
						error
					});
					this.showErrorMessage("IO Mapping", String(error));
				}
			)
	}

	setSpecialIOEvent( i, val) {
		//console.log("setting special IO("+i+") event="+val);
		var key = "special_io_"+i;
		var objKey = key+".event";
		var cur = this.state.special_io_obj;
		cur[objKey]=val;
		this.setState({special_io_obj:cur});
	}

	createSpecialIOExtra(i) {
		const event = this.state.special_io_obj["special_io_" + i + ".event"];
		const value = this.state.special_io_obj["special_io_" + i + ".value"];
		if (!event || event === 'next_stop') return <span />;

		if (event === 'elevator_touchpad') return <span />;

		if (event === 'multimedia_message') {
			const extraString = this.state.special_io_obj["special_io_" + i + ".extra"] || "";
			const extra = {x:'0', y:'0', width:'0'};
			extraString.split(';').forEach(pair => {
				const [key, val] = pair.split('=', 2);
				if (Object.prototype.hasOwnProperty.call(extra, key) && val !== undefined) {
					extra[key] = val;
				}
			});
			const handleExtraChange = (field, newValue) => {
				const normalizedValue = newValue === '' ? '0' : String(Math.max(0, Number.parseInt(newValue, 10) || 0));
				const next = {...extra, [field]:normalizedValue};
				this.setSpecialIOExtra(i, `x=${next.x};y=${next.y};width=${next.width}`);
			};
			return <Stack spacing={1.25}>
				<Typography variant="body2" color='text.secondary'>
					{ETVConstants.trans("multimedia_message_expl")}
				</Typography>
				<Box sx={{display:'grid', gridTemplateColumns:{xs:'1fr', sm:'repeat(3, minmax(90px, 1fr))'}, gap:1}}>
					<TextField label="X (px)" size="small" type="number" value={extra.x}
						inputProps={{min:0}} onChange={(e)=>handleExtraChange('x', e.target.value)}/>
					<TextField label="Y (px)" size="small" type="number" value={extra.y}
						inputProps={{min:0}} onChange={(e)=>handleExtraChange('y', e.target.value)}/>
					<TextField label="Width (px)" size="small" type="number" value={extra.width}
						inputProps={{min:0}} helperText="0 = fullscreen"
						onChange={(e)=>handleExtraChange('width', e.target.value)}/>
				</Box>
			</Stack>;
		}

		if (event === 'streaming') {
			const extraString = this.state.special_io_obj["special_io_" + i + ".extra"] || "";

			const extra = {};
			extraString.split(";").forEach(pair => {
				const [key, val] = pair.split("=");
				if (key && val !== undefined) extra[key] = val;
			});

			const handleExtraChange = (field, newVal) => {
				const newExtra = {
					x: extra.x || 0,
					y: extra.y || 0,
					width: extra.width || 100,
					height: extra.height || 100,
					touch: extra.touch || "no",
					originalWidth: extra.originalWidth || 1920,
					originalHeight: extra.originalHeight || 1080,
					websocket: extra.websocket || "",
					[field]: newVal
				};
				let newExtraString = `x=${newExtra.x};y=${newExtra.y};width=${newExtra.width};height=${newExtra.height};touch=${newExtra.touch}`;
				if (newExtra.touch === 'yes') {
					newExtraString += `;originalWidth=${newExtra.originalWidth};originalHeight=${newExtra.originalHeight};websocket=${newExtra.websocket}`;
				}
				this.setSpecialIOExtra(i, newExtraString);
			};

			return (
				<div style={{
					display: 'flex',
					flexDirection: 'column',
					gap: '16px',
					padding: '16px',
					border: '1px solid #ccc',
					borderRadius: '8px',
					backgroundColor: '#f9f9f9',
					width: 300
				}}>
					<div style={{ display: 'flex', gap: '16px' }}>
						<TextField
							label="X"
							size="small"
							type="number"
							variant="outlined"
							value={extra.x || ''}
							onChange={(e) => handleExtraChange('x', e.target.value)}
							fullWidth
						/>
						<TextField
							label="Y"
							size="small"
							type="number"
							variant="outlined"
							value={extra.y || ''}
							onChange={(e) => handleExtraChange('y', e.target.value)}
							fullWidth
						/>
					</div>
					<div style={{ display: 'flex', gap: '16px' }}>
						<TextField
							label="Width"
							size="small"
							type="number"
							variant="outlined"
							value={extra.width || ''}
							onChange={(e) => handleExtraChange('width', e.target.value)}
							fullWidth
						/>
						<TextField
							label="Height"
							size="small"
							type="number"
							variant="outlined"
							value={extra.height || ''}
							onChange={(e) => handleExtraChange('height', e.target.value)}
							fullWidth
						/>
					</div>
				</div>
			);
		}
	}



	setSpecialIOValue( i, val) {
		console.log("setting special IO("+i+") event="+val);
		var key = "special_io_"+i;
		var objKey = key+".value";
		var cur = this.state.special_io_obj;
		cur[objKey]=val;
		this.setState({special_io_obj:cur});
		//console.log("setting special IO("+i+") value="+val);
	}

	setSpecialIOExtra( i, val) {
		console.log("setting special IO("+i+") extra="+val);
		var key = "special_io_"+i;
		var objKey = key+".extra";
		var cur = this.state.special_io_obj;
		cur[objKey]=val;
		this.setState({special_io_obj:cur});
	}

	createSpecialIO(i) {
		return <Typography variant='subtitle2' style={{fontWeight:700}}>Special IO {i}</Typography>
	}

	createSpecialIOValue(i) {
		const event = this.state.special_io_obj["special_io_"+i+".event"];
		const isMultimedia = event === 'multimedia_message';
		return (
		  <FormControl fullWidth>
			<TextField
			  size="small"
			  label={isMultimedia ? 'File name' : undefined}
			  required={isMultimedia}
			  placeholder={isMultimedia ? 'Example: alarm.mp4' : 'Enter value'}
			  helperText={isMultimedia ? 'Required; file must be in /elevatortv/channel_extra' : undefined}
			  variant="outlined"
			  value={this.state.special_io_obj["special_io_"+i+".value"]}
			  onChange={(e) => {
				this.setSpecialIOValue(i, e.target.value);
			  }}
			/>
		  </FormControl>
		);
  	}

	createSpecialIOEventDropDown(i) {
		var label = "Special IO Event";
		var value = this.state.special_io_obj["special_io_"+i+".event"];
		return (
			<FormControl fullWidth>
			  <InputLabel>{label}</InputLabel>
			  <Select
			  	size="small"
				value={value}
				label={label}
				onChange={(e)=>{this.setSpecialIOEvent(i,e.target.value)}}>
				  <MenuItem key={"special_io_"+i+"_next_stop"} value={"next_stop"}>Next Stop</MenuItem>
				  <MenuItem key={"special_io_"+i+"_message"} value={"message"}>Show Message</MenuItem>
				  <MenuItem key={"special_io_"+i+"_streaming"} value={"streaming"}>Streaming</MenuItem>
				  <MenuItem key={"special_io_"+i+"_elevator_touchpad"} value={"elevator_touchpad"}>Elevator Touchpad</MenuItem>
				  <MenuItem key={"special_io_"+i+"_elevator_touchpad"} value={"multimedia_message"}>Multimedia Message</MenuItem>
			  </Select>
			</FormControl>
		);		
	}

	deleteSpecialIOInfo(i) {
		const curObj = { ...this.state.special_io_obj }; // shallow copy for immutability
		delete curObj["special_io_" + i + ".event"];
		delete curObj["special_io_" + i + ".value"];
		delete curObj["special_io_" + i + ".extra"];
		this.setState({ special_io_obj: curObj });
	}

    render() {
		const adam1Bits = [...Array(16)].map((_, i) => i);
		const adam2Bits = [...Array(16)].map((_, i) => i + 16);
		const specialIOs = this.getSpecialIOs();

      return(
		<Box sx={{display:'flex', flexDirection:'column', gap:2.5, pb:3}}>
			<Paper elevation={0} sx={{p:2.5, border:'1px solid #d8dee4', borderRadius:2, backgroundColor:'#fff'}}>
				<Box>
					<FormLabel>ADAM Input Mapping: {this.props.device_id}</FormLabel>
					<Typography variant='body2' color='text.secondary' sx={{mt:0.5}}>
						If you need more than 32 inputs, then you will need to add 2 x Adam4051.
					</Typography>
				</Box>

				<Stack spacing={2} sx={{mt:2.5}}>
					<Box>
						<Typography variant='subtitle2' sx={{fontWeight:700, mb:1}}>Adam 1 Inputs</Typography>
						<Box sx={{display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(190px, 1fr))', gap:1.5}}>
							{adam1Bits.map((bitNr) => (
								<Box key={"bit_grid_"+bitNr}>
									{this.createDropDown('bit_'+bitNr)}
								</Box>
							))}
						</Box>
					</Box>
					<Box>
						<Typography variant='subtitle2' sx={{fontWeight:700, mb:1}}>Adam 2 Inputs</Typography>
						<Box sx={{display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(190px, 1fr))', gap:1.5}}>
							{adam2Bits.map((bitNr) => (
								<Box key={"bit_grid_"+bitNr}>
									{this.createDropDown('bit_'+bitNr)}
								</Box>
							))}
						</Box>
					</Box>
				</Stack>

				<Divider sx={{my:2.5}}/>

				<Stack spacing={1.5}>
					<Stack direction={{xs:'column', sm:'row'}} justifyContent='space-between' alignItems={{xs:'stretch', sm:'center'}} spacing={1}>
						<Typography variant='subtitle1' sx={{fontWeight:700}}>Special IO</Typography>
						<Typography variant='caption' color='text.secondary'>{specialIOs.length} configured</Typography>
					</Stack>
					{specialIOs.length === 0 ? (
						<Box sx={{border:'1px dashed #c8d0d9', borderRadius:1, p:2, color:'text.secondary'}}>
							<Typography variant='body2'>No special IO configured.</Typography>
						</Box>
					) : specialIOs.map((ioKey) => (
						<Box key={ioKey} sx={{display:'grid', gridTemplateColumns:{xs:'1fr', md:'120px minmax(180px, 220px) minmax(220px, 1fr) 44px'}, gap:1.5, alignItems:'start', border:'1px solid #e1e4e8', borderRadius:1.5, p:1.5, backgroundColor:'#fbfcfe'}}>
							<Box sx={{pt:{md:1}}}>{this.createSpecialIO(ioKey)}</Box>
							<Box>{this.createSpecialIOEventDropDown(ioKey)}</Box>
							<Box>
								{this.createSpecialIOValue(ioKey)}
								<Box sx={{mt:1}}>{this.createSpecialIOExtra(ioKey)}</Box>
							</Box>
							<IconButton aria-label={"delete special io "+ioKey} color='error' onClick={() => { this.deleteSpecialIOInfo(ioKey) }}>
								<Delete />
							</IconButton>
						</Box>
					))}
				</Stack>
			</Paper>

			<Paper elevation={0} sx={{p:2.5, border:'1px solid #d8dee4', borderRadius:2, backgroundColor:'#fff'}}>
				<FormLabel>Digital IO Inversion (XOR Mask)</FormLabel>
				<Typography variant='body2' color='text.secondary' sx={{mt:0.5}}>
					Set a digit to 1 to invert that input. The rightmost digit is bit 0 / Adam 1 input 0.
				</Typography>
				<Box sx={{maxWidth:720, mt:2}}>
					<Stack direction='row' alignItems='center' justifyContent='space-between' spacing={1} sx={{mb:1}}>
						<Box sx={{border:'1px solid #d0d7de', borderRadius:1, px:1, py:0.5, backgroundColor:'#f6f8fa'}}>
							<Typography variant='caption' sx={{fontFamily:'monospace', fontWeight:700}}>bit {MAX_IO_BITS - 1}</Typography>
						</Box>
						<Typography variant='caption' color='text.secondary' sx={{flex:1, textAlign:'center'}}>
							Adam 2 inputs &lt; mask direction &gt; Adam 1 inputs
						</Typography>
						<Box sx={{border:'1px solid #1976d2', borderRadius:1, px:1, py:0.5, backgroundColor:'#eaf3ff', color:'#1976d2'}}>
							<Typography variant='caption' sx={{fontFamily:'monospace', fontWeight:700}}>bit 0</Typography>
						</Box>
					</Stack>
					<TextField
						fullWidth
						size='small'
						key='xor_mask'
						variant='outlined'
						value={this.state.xor_mask}
						helperText="Example: 00000000000000000000000000000001 inverts bit 0"
						inputProps={{maxLength: MAX_IO_BITS, style:{fontFamily:'monospace', fontSize:16, letterSpacing:3, textAlign:'center', padding:'12px 10px', background:'#fbfdff'}}}
						onChange={(e)=>{this.setState({xor_mask:e.target.value.replace(/[^01]/g, '')})}} />
				</Box>
			</Paper>
			
			<Paper elevation={0} sx={{p:2.5, border:'1px solid #d8dee4', borderRadius:2, backgroundColor:'#fff'}}>
				<Stack direction={{xs:'column', sm:'row'}} justifyContent='space-between' alignItems={{xs:'stretch', sm:'center'}} spacing={1.5}>
					<FormLabel>Setting Door Behaviour</FormLabel>
					<Button size='small' color="primary" variant='contained' onClick={() => this.setDefaultDoor()}>Set Default</Button>
				</Stack>
				<Box sx={{display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(180px, 1fr))', gap:1.5, mt:2}}>
					{['closed', 'opening', 'open', 'closing'].map((key) => (
						<Box key={"door_"+key}>{this.createDoorDropDown(key)}</Box>
					))}
				</Box>
			</Paper>

			<Paper elevation={0} sx={{p:2.5, border:'1px solid #d8dee4', borderRadius:2, backgroundColor:'#fff'}}>
				<FormLabel>Out of Service Notification</FormLabel>
				<Box sx={{display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(180px, 1fr))', gap:1.5, mt:2}}>
					<TextField size='small' key='email' label="email" variant='outlined' value='' />
					<TextField size='small' key='sms' label="SMS" variant='outlined' value='' />
					<TextField size='small' key='trigger' label="trigger [min]" variant='outlined' value='' />
				</Box>
			</Paper>

			<MessageDialog
				open={this.state.window==='message_div'}
				onClose={() => this.closeInfoMessage()}
				title={this.state.info_title}
				message={this.state.info_message}
				type={this.state.info_type}
			/>
		   	</Box>
			);
	}
}

export default EditIO
